export default __webpack_public_path__ + "static/media/ima-europe-logo.7856afff.png";